export const GMD_PER_USD = 74;

export const BILLING_TIERS = [
    {
        id: 'starter',
        name: 'Starter',
        monthlyUsd: 80,
        yearlyUsd: 800,
        includedSeats: 8,
        extraSeatUsd: 10,
        setupUsd: 150,
        blurb: 'Staff portal, new policy, approvals, digital cards, QR verify, motor print certificate.'
    },
    {
        id: 'standard',
        name: 'Standard',
        monthlyUsd: 150,
        yearlyUsd: 1500,
        includedSeats: 15,
        extraSeatUsd: 10,
        setupUsd: 250,
        blurb: 'Starter plus claims, import, API keys, logo, and up to 15 staff seats.'
    },
    {
        id: 'growth',
        name: 'Growth',
        monthlyUsd: 300,
        yearlyUsd: 3000,
        includedSeats: 40,
        extraSeatUsd: 8,
        setupUsd: 400,
        blurb: 'Standard plus higher API volume, 40 seats, and priority support.'
    }
];

export function findBillingTier(id) {
    return BILLING_TIERS.find((t) => t.id === id) || BILLING_TIERS[1];
}

export function billingRecord(tierId, cycle, setBy) {
    const t = findBillingTier(tierId);
    const yearly = cycle === 'yearly';
    return {
        tier: t.id,
        tierName: t.name,
        cycle: yearly ? 'yearly' : 'monthly',
        priceUsd: yearly ? t.yearlyUsd : t.monthlyUsd,
        monthlyUsd: t.monthlyUsd,
        yearlyUsd: t.yearlyUsd,
        includedSeats: t.includedSeats,
        extraSeatUsd: t.extraSeatUsd,
        setupUsd: t.setupUsd,
        setAt: new Date().toISOString(),
        setBy: setBy || ''
    };
}

export function formatUsd(n) {
    return '$' + Number(n || 0).toLocaleString();
}

export function usdToGmd(n) {
    return Math.round(Number(n || 0) * GMD_PER_USD);
}

export function formatGmd(n) {
    return 'GMD ' + usdToGmd(n).toLocaleString();
}
